<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="581" scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Sửa điểm danh
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <CheckinConfirmDialog :state="confirmDialog" :type="type" @confirm="save" />
        <EditConfirmDialog :state="editDialog" :type="editType" @confirm="edit" />
        <v-form ref="form" class="pt-4">
          <v-row>
            <v-col> Ngày {{ getCurrentDate }} </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <CardStudentName :student="selectedAttendance.student" />
            </v-col>
            <v-col cols="6" class="d-flex justify-space-between align-center">
              <div>
                <p class="text-caption my-0">Ngày sinh</p>
                <span>{{ $_get(selectedAttendance, 'student.dob', '') | ddmmyyyy }}</span>
              </div>
              <div>
                <p class="text-caption my-0">Mã số</p>
                <span>{{ $_get(selectedAttendance, 'student.code', '') | getStudentCode }}</span>
              </div>
              <div>
                <p class="text-caption my-0">Lớp</p>
                <span>{{ $_get(selectedAttendance, 'class.title', '') }}</span>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="d-flex align-center"> Giờ đến (24h) <span class="error--text">*</span> </v-col>
            <v-col cols="8" class="d-flex align-center">
              <TimeInput
                label="Giờ đến (24h)"
                outlined
                dense
                outline
                :date.sync="checkIn"
                :selectedDate="getCurrentDate"
                class="required"
                :rules="[$rules.required, $rules.time]"
                :disabled="isCheckInDisabled"
                validate-on-blur
              />
              <div v-if="oldIn">
                <v-icon right @click="openEditConfirm('in')" v-if="isCheckInDisabled">mdi-pencil</v-icon>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="d-flex align-center">Giờ về (24h) </v-col>
            <v-col cols="8" class="d-flex align-center">
              <TimeInput
                label="Giờ về (24h)"
                outlined
                dense
                outline
                :selectedDate="getCurrentDate"
                :rules="[$rules.time]"
                :date.sync="checkOut"
                :disabled="isCheckOutDisabled"
                validate-on-blur
              />
              <div v-if="oldIn">
                <v-icon right @click="openEditConfirm('out')" v-if="isCheckOutDisabled"> mdi-pencil </v-icon>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn class="ma-2" color="blue darken-4" outlined depressed @click="cancel">Đóng</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="openDialog">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
import CardStudentName from '@/components/basic/card/CardStudentName'
import moment from 'moment'
import TimeInput from '@/components/basic/TimeInput.vue'
import CheckinConfirmDialog from './CheckinConfirmDialog.vue'
import EditConfirmDialog from './EditConfirmDialog.vue'

export default {
  components: {
    CardStudentName,
    TimeInput,
    CheckinConfirmDialog,
    EditConfirmDialog,
  },
  data() {
    return {
      dialog: false,
      checkIn: '',
      checkOut: '',
      oldIn: '',
      oldOut: '',
      type: '',
      isCheckInDisabled: true,
      isCheckOutDisabled: true,
      confirmDialog: false,
      editDialog: false,
      editType: '',
    }
  },
  props: {
    state: Boolean,
    selectedAttendance: Object,
    checkinObject: Object,
  },
  computed: {
    ...mapState('attendance', ['date']),

    getCurrentDate() {
      return moment(this.selectedAttendance.time).format('DD/MM/YYYY')
    },
    checkInTime() {
      return this.checkIn ? moment(this.checkIn).format('HH:mm') : null
    },
    checkOutTime() {
      return this.checkOut ? moment(this.checkOut).format('HH:mm') : null
    },
  },
  methods: {
    ...mapActions('attendance', ['updateAttendance', 'createAttendance', 'createCheckinAdmin', 'updateCheckinAdmin']),
    checkInChange(data) {
      this.checkIn = moment(data, 'hh:mm').toISOString()
    },
    checkOutChange(data) {
      this.checkOut = moment(data, 'hh:mm').toISOString()
    },
    async save(data) {
      if (!this.$refs.form.validate()) return
      if (this.checkOut && this.checkIn && moment(this.checkOut).isBefore(moment(this.checkIn))) {
        this.$alert.error('Giờ về phải lớn hơn giờ đến')
        return
      }

      try {
        this.$loading.active = true
        if (!get(this.checkinObject, 'id', '')) {
          const checkInData = {
            checkIn: this.checkIn,
            checkOut: this.checkOut || null,
            send: data.send,
            status: this.checkOut ? 'left' : 'attendance',
            student: get(this.selectedAttendance, 'student.id', ''),
            attendance: this.selectedAttendance.id,
          }

          await this.createCheckinAdmin(checkInData)

          const attendanceData = {
            id: this.selectedAttendance.id,
            status: this.checkOut ? 'left' : 'attendance',
            time: this.checkOut ? this.checkOut : this.checkIn,
          }
          await this.updateAttendance(attendanceData)
          this.dialog = false
        } else {
          if (this.checkinObject.checkOut && !this.checkOut) {
            this.$alert.error('Học sinh đã rời trường, giờ về là bắt buộc')
            return
          }
          const checkInData = {
            id: this.checkinObject.id,
            checkIn: this.checkIn,
            checkOut: this.checkOut,
            type: data.type,
            send: data.send,
            status: this.checkOut ? 'left' : 'attendance',
          }

          await this.updateCheckinAdmin({
            ...checkInData,
          })

          await this.updateAttendance({
            id: this.selectedAttendance.id,
            status: this.checkOut ? 'left' : 'attendance',
            time: this.checkOut ? this.checkOut : this.checkIn,
          })
        }

        this.$alert.updateSuccess()
        this.dialog = false
        // this.$emit('attendanceUpdated')
      } catch (error) {
        console.error(error)
        this.$alert.updateError()
      } finally {
        this.$loading.active = false
      }
    },
    openDialog() {
      const inChange = this.oldIn !== this.checkIn
      const outChange = this.oldOut !== this.checkOut
      const type = inChange && outChange ? 'both' : inChange ? 'in' : outChange ? 'out' : ''
      this.type = type
      this.confirmDialog = !this.confirmDialog
    },
    reset() {
      this.$refs.form.reset()
    },
    cancel() {
      this.dialog = false
    },
    openEditConfirm(type) {
      this.editType = type
      this.editDialog = !this.editDialog
    },
    edit(type) {
      if (type === 'in') {
        this.toggleCheckInEdit()
      } else if (type === 'out') {
        this.toggleCheckOutEdit()
      }
    },
    toggleCheckInEdit() {
      this.isCheckInDisabled = !this.isCheckInDisabled
    },
    toggleCheckOutEdit() {
      this.isCheckOutDisabled = !this.isCheckOutDisabled
    },
  },
  watch: {
    state() {
      this.dialog = true
      if (this.checkinObject && this.checkinObject.id) {
        this.checkIn = this.checkinObject.checkIn ? moment(this.checkinObject.checkIn).toISOString() : ''
        this.checkOut = this.checkinObject.checkOut ? moment(this.checkinObject.checkOut).toISOString() : ''
        this.oldIn = this.checkinObject.checkIn ? moment(this.checkinObject.checkIn).toISOString() : ''
        this.oldOut = this.checkinObject.checkOut ? moment(this.checkinObject.checkOut).toISOString() : ''
        this.isCheckInDisabled = !!this.checkIn
        this.isCheckOutDisabled = !!this.checkOut
      } else {
        this.checkIn = ''
        this.checkOut = ''
        this.oldIn = ''
        this.oldOut = ''
        this.isCheckInDisabled = false
        this.isCheckOutDisabled = false
      }
    },
  },
}
</script>

<style scoped>
.vis-hidden {
  visibility: hidden;
}
</style>
